import React from "react";
import Switch from "../../../components/Switch/Switch";
import ExcelBulkUpload from "../../ExcelBulkUpload/ExcelBulkUpload";

const ExcelBulkUploadSection = ({ loader, downloadExcel, excelFileReader, bulkUploadFile, updateFlag, setUpdateFlag }) => (
  <React.Fragment>
    <Switch
      label="Update students Data"
      onChange={() => setUpdateFlag(!updateFlag)}
      id="updateFlag"
      name="updateFlag"
      checked={updateFlag}
    />
    <ExcelBulkUpload
      loader={loader} downloadExcel={downloadExcel}
      excelFileReader={excelFileReader} bulkUploadFile={bulkUploadFile}
    />
  </React.Fragment>
);

export default ExcelBulkUploadSection;
